import { Component } from '@angular/core';
import { ToastController, ModalController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { Params } from '../../params';
import * as XLSX from 'xlsx';

@Component({
    selector: 'month-selector-modal',
    templateUrl: 'month-selector-modal.html'
})
export class MonthSelectorModal {
    public months: Array<{ name: string, value: number }> = [];
    public selectedMonths: Array<number> = [];
    public customers = [];

    constructor(public params: NavParams,
        public modalCtrl: ModalController,
        private alertCtrl: AlertController,
        public toastCtrl: ToastController,
        private viewCtrl: ViewController,

    ) {
        this.customers = this.params.get('customers');
        this.months = this.getMonths();
    }

    private getMonths(): Array<{ name: string, value: number }> {
        let months = [];
        for (let i = 1; i <= 12; i++) {
            let monthName = new Date(0, i, 0).toLocaleString('es', { month: 'long' });
            monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
            months.push({ name: monthName, value: i });
        }
        return months;
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    filter() {
        console.log(this.customers);

        if (typeof this.selectedMonths === 'undefined' || this.selectedMonths === null || this.selectedMonths.length === 0) {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Debe seleccionar un mes',
                buttons: ['OK']
            }).present();
            return
        }
        console.log(this.selectedMonths);
        let ok = [];
        // with two digits
        for (const month of this.selectedMonths) {
            this.viewBirthdaysMonth(ok, month);
        }

        // get initials letter of array of month for name of file
        const monthName = this.selectedMonths.map(m => this.months.find(x => x.value === m).name.charAt(0).toUpperCase()).join('');
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ok.sort((a, b) => a['Cumpleaños'] - b['Cumpleaños']));
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
        XLSX.writeFile(wb, 'Cumpleaños_' + monthName + '.xlsx');
        this.viewCtrl.dismiss();
        this.alertCtrl.create({
            title: 'Descarga de Cumpleaños',
            subTitle: 'Se ha descargado un archivo con los cumpleaños del mes seleccionado',
            buttons: ['OK']
        }).present();


    }


    private viewBirthdaysMonth(ok: any[], month: number) {
        const selectedMonthParsed = month < 10 ? '0' + month : month;
        // calculate age with c.birth in format YYYY-MM-DD and actual date
        const calculateAge = (birthDat) => {
            const today = new Date();
            const birthDate = new Date(birthDat);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        };

        for (let i = 0; i < this.customers.length; i++) {
            let c = this.customers[i];
            let s = {
                "Fecha de Nacimiento": c.birth ? c.birth : 'sin datos',
                "Cumpleaños": c.birth ? c.birth.split('-')[2] + "/" + c.birth.split('-')[1] : 'sin datos',
                "Edad": c.birth ? calculateAge(c.birth) : 'sin datos',
                "Activo": c.active ? 'si' : 'no',
                "Cliente": Params.parse_xls(c.name) + " " + Params.parse_xls(c.lastname),
                "Rut": c.rut ? c.rut : 'sin datos',
                "Email": c.email ? c.email : 'sin datos',
                "Direccion": c.address ? Params.parse_xls(c.address) + ", " + Params.parse_xls(c.address_info) : 'sin datos',
                "Condicion": c.condition ? c.condition : 'sin datos',
                "Comidas": c.foods ? c.foods : 'sin datos',
                "Telefono": c.phone ? c.phone : 'sin datos',
                "Plan": c.plan ? c.plan : 'sin datos',
                "Ruta": c.route ? c.route : 'sin datos',
                "Ruta Posicion": c.route_pos ? c.route_pos : 'sin datos',
                "Ruta Observaciones": c.route_obs ? c.route_obs : 'sin datos',
                "Sexo": c.sexo ? c.sexo : 'sin datos',
                "Altura": c.tall ? c.tall : 'sin datos',
                "Fecha de Ingeso": c.datestart ? c.datestart : 'sin datos',
                "Delivery": c.delivery ? c.delivery + " comidas" : 'sin datos',
            };

            const monthBirth = c.birth ? c.birth.split('-')[1] : null;
            if (monthBirth == selectedMonthParsed || month == 0) {
                ok.push(s);
            }
        }

        return ok;
    }
}



// WEBPACK FOOTER //
// ./src/pages/customers/month-selector-modal/month-selector-modal.ts